<template>
  <header class="header-atom" :class="{ 'light-theme': lightTheme, 'transparent-bg': transparentBackground }">
    <div class="header-atom__content">
      <router-link
        to="/"
        exact
        @click="
          closeMenu();
          trackClick('Header Logo');
        "
      >
        <div class="logo">
          <img :src="logo" :class="{ resizeLogo: isSmallerLogo }" />
        </div>
      </router-link>
    </div>

    <nav :class="['header-atom__nav', { 'menu-open': menuOpen, 'not-home': !onHomePage && width < 1050 }]">
      <div v-if="width < 1050" class="header-atom__nav__hamburger">
        <i @click="toggleMenu" :class="['material-symbols-outlined', { close: menuButton === 'close' }]">{{ menuButton }}</i>
      </div>

      <div v-if="menuOpen || width > 1050" class="header-atom__nav__links">
        <router-link
          @click="
            closeMenu();
            trackClick('Nav-Byggutsläppslistan');
          "
          to="/"
          exact
          exact-active-class="active-link"
        >
          {{ navText.home }}
        </router-link>

        <router-link
          @click="
            closeMenu();
            trackClick('Nav-Projekt');
          "
          v-if="menuOpen && width < 1050"
          to="/projects"
          exact
          exact-active-class="active-link"
        >
          {{ navText.projects }}
        </router-link>

        <router-link
          @click="
            closeMenu();
            trackClick('Nav-Kommuner');
          "
          v-if="menuOpen && width < 1050"
          to="/communes"
          exact
          exact-active-class="active-link"
        >
          {{ navText.communes }}
        </router-link>

        <router-link
          @click="
            closeMenu();
            trackClick('Nav-Byggherrar');
          "
          v-if="menuOpen && width < 1050"
          to="/builders"
          exact
          exact-active-class="active-link"
        >
          {{ navText.builders }}
        </router-link>

        <router-link
          @click="
            closeMenu();
            trackClick('Nav-Byggnadstyper');
          "
          v-if="menuOpen && width < 1050"
          to="/building-types"
          exact
          exact-active-class="active-link"
        >
          {{ navText.buildingTypes }}
        </router-link>

        <router-link
          @click="
            toggleMenu();
            trackClick('Nav-Minska utsläppen');
          "
          to="/future"
          exact
          exact-active-class="active-link"
        >
          {{ navText.future }}
        </router-link>

        <router-link
          @click="
            toggleMenu();
            trackClick('Nav-Om initiativet');
          "
          to="/about"
          exact
          exact-active-class="active-link"
        >
          {{ navText.about }}
        </router-link>
      </div>
    </nav>
  </header>
</template>

<script>
import { inject, computed } from 'vue';

export default {
  props: {
    lightTheme: {
      type: Boolean,
    },
    transparentBackground: {
      type: Boolean,
      default: false,
    },
    isSmallerLogo: {
      type: Boolean,
    },
  },
  setup() {
    const language = inject('language'); // Get the language context
    const isEnglish = computed(() => language.value === 'en'); // Determine if it's English

    const navText = computed(() => ({
      home: isEnglish.value ? 'Embodied Carbon Declared' : 'Byggutsläppslistan',
      projects: isEnglish.value ? 'Projects' : 'Projekt',
      communes: isEnglish.value ? 'Municipalities' : 'Kommuner',
      builders: isEnglish.value ? 'Developers' : 'Byggherrar',
      buildingTypes: isEnglish.value ? 'Building types' : 'Byggnadstyper',
      future: isEnglish.value ? 'Reducing emissions' : 'Minska utsläppen',
      about: isEnglish.value ? 'About the initiative' : 'Om initiativet',
    }));

    return {
      isEnglish,
      navText,
    };
  },
  data() {
    return {
      menuOpen: false,
      width: window.innerWidth,
      menu: require('@/assets/logotypes/menu.png'),
    };
  },
  computed: {
    menuButton() {
      return this.menuOpen ? 'close' : 'drag_handle';
    },
    logo() {
      return this.lightTheme ? require('@/assets/logotypes/logo_black.svg') : require('@/assets/logotypes/logo_white.svg');
    },
    onHomePage() {
      return this.$route.path === '/';
    },
  },
  methods: {
    toggleMenu() {
      this.menuOpen = !this.menuOpen;
      document.documentElement.style.overflow = this.menuOpen ? 'hidden' : 'auto';
    },
    closeMenu() {
      this.menuOpen = false;
      document.documentElement.style.overflow = 'auto';
    },
    trackClick(label) {
      if (this.$gtag) {
        this.$gtag.event('click', {
          event_category: 'navigation',
          event_label: label,
        });
      }
    },
    updateWidth() {
      this.width = window.innerWidth;
    },
  },
  mounted() {
    window.addEventListener('resize', this.updateWidth);
  },
  ounmounted() {
    window.removeEventListener('resize', this.updateWidth);
  },
  watch: {
    //Disables scrolling when menu is open
    menuOpen: function () {
      if (this.menuOpen && this.width < 1000) {
        document.documentElement.style.overflow = 'hidden';
        return;
      }
      document.documentElement.style.overflow = 'auto';
    },
  },
};
</script>

<style scoped>
.header-atom {
  display: flex;
  align-items: center;
  padding: 40px;
  background-color: black;
  height: 135.5px;
}
.logo {
  width: 120px;
}
.resizeLogo {
  width: 160px;
}

.menu {
  display: block;
  height: 40px;
}
.header-atom {
  width: 100%;
}
.header-atom__nav {
  display: flex;
  gap: 25px;
  justify-content: right;
  align-items: center;
  width: 100%;
  font-size: 27px;
  margin-right: 10px;
}
.header-atom__nav__links {
  display: flex;
  gap: 25px;
  justify-content: right;
  width: 100%;
  margin-top: 20px;
  margin-right: -20px;
  font-size: 17px;
  color: white;
}
.header-atom__nav__links a {
  padding: 4px 10px;
}
.header-atom__nav__links a:hover {
  background-color: #2637f3;
  color: white;
}
.header-atom__nav__links a:active {
  background-color: #2637f3;
  color: white;
}
.header-atom__nav__hamburger {
  display: none;
  cursor: pointer;
  font-size: 30px;
  color: var(--color-light);
  margin-left: auto;
  display: grid;
  margin-bottom: 40px;
}
.header-atom__nav__hamburger i {
  font-size: 50px;
  margin-right: -15px;
}
.close {
  color: black;
}
a {
  text-decoration: none;
  color: var(--color-dark);
  font-family: 'fet', sans-serif;
  letter-spacing: 1.5px;
}
a.active-link {
  color: var(--color-light);
}

/* light theme */
.light-theme {
  background-color: white;
}
.light-theme * {
  color: black;
}
.transparent-bg {
  background-color: transparent;
  z-index: 999;
  position: absolute;
  right: 0;
  left: 0;
}

.material-symbols-outlined {
  font-variation-settings: 'FILL' 0, 'wght' 100, 'GRAD' 700, 'opsz' 50;
}

/* Media Quiery */
@media all and (min-width: 1050px) {
  .resizeLogo {
    width: 190px;
  }
  .logo {
    width: 150px;
    margin-left: 0px;
  }
}
@media all and (max-width: 1050px) {
  .menu-open {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: white;
    z-index: 99;
    padding: 40px 20px 20px 20px;
    display: flex;
    flex-direction: column;
  }
  .header-atom {
    padding: 40px 25px;
  }
  .header-atom__nav {
    height: 100%;
  }
  .header-atom__nav:is(.not-home):not(.menu-open) {
    margin-top: 10px;
  }
  .header-atom__nav__links {
    color: black;
    flex-direction: column;
    gap: 10px;
    font-size: 26px;
    letter-spacing: 0.5px;
    text-align: center;
    justify-content: center;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1;
    line-height: 1em;
  }
  .header-atom__nav__hamburger {
    display: block;
    height: 40px;
    z-index: 999;
    align-content: center;
    margin-top: 0px;
  }

  .header-atom__nav__links a {
    display: flex;
    justify-content: center;
    letter-spacing: 1px;
    padding: 10px;
  }
  .header-atom__nav__hamburger i.close {
    height: 40px;
    margin: 0 27px 0 0;
    font-variation-settings: 'wght' 200;
  }
}
</style>
